import { fetchUtils } from '$lib/utils/fetchUtils'
import { type Catalog, DefaultCatalog } from './types/catalog'
import { DefaultNotification, NotificationType, type Notification } from '$types/notification'
import { modals } from 'svelte-modals'
import { t } from '$i18n/i18n'
import { addNotification } from '$lib/stores'
import Modal from '$lib/organisms/Modal.svelte'
import { mmpvState } from '$lib/mmpv/mmpv.state.svelte'
import { buildExtendedMaterials } from '$lib/mmpv/util/materialSubstituteUtil'
import { get } from 'svelte/store'

export function addCatalogToState(data: Catalog) {
	const newCatalog = Object.assign(DefaultCatalog(), data)
	mmpvState.catalogs = [...mmpvState.catalogs, newCatalog]
	mmpvState.treeExpansionStates.set(newCatalog.name, [])
}

export async function fetchCatalogs() {
	await fetchUtils
		.get('/api/catalogs/list')
		.then((data) => {
			mmpvState.catalogs = [...(data ?? [])]
			mmpvState.catalogs.forEach((catalog) => mmpvState.treeExpansionStates.set(catalog.name, []))
			mmpvState.selectedCatalog =
				mmpvState.catalogs.find((c) => c.name === mmpvState.selectedCatalog?.name) ??
				mmpvState.catalogs[0] ??
				DefaultCatalog()
			mmpvState.allExtendedMaterials = buildExtendedMaterials($state.snapshot(mmpvState.catalogs))
		})
		.catch(fetchUtils.catchErrorAndShowNotification())
}

export async function handleDeleteCatalog(catalog: Catalog) {
	await modals.open(Modal, {
		title: get(t)('UI.mmpv.delete.modal.title', { entity: catalog.name }),
		message: get(t)('UI.mmpv.delete.catalog.modal.message', { catalog: catalog.name }),
		denyText: get(t)('UI.delete'),
		onDeny: () => {
			deleteCatalog(catalog)
			modals.close()
		}
	})
}

function deleteCatalog(catalog: Catalog) {
	fetchUtils
		.post(`/api/catalog/${catalog.id}/delete`, catalog)
		.then(() => {
			const notification: Notification = DefaultNotification(
				'Katalog erfolgreich entfernt.', // TODO make string resource
				NotificationType.SUCCESS,
				true
			)
			addNotification(notification)
			mmpvState.catalogs = mmpvState.catalogs.filter(
				(existingCatalog: Catalog) => existingCatalog !== catalog
			)
			mmpvState.treeExpansionStates.delete(catalog.name)
			mmpvState.allExtendedMaterials = buildExtendedMaterials($state.snapshot(mmpvState.catalogs))
			if (mmpvState.selectedCatalog === catalog) {
				mmpvState.selectedCatalog = mmpvState.catalogs[0] ?? DefaultCatalog()
			}
		})
		.catch(fetchUtils.catchErrorAndShowNotification())
}
